
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSharedGamePlan } from '@/services/gamePlanService';
import { GamePlanDisplay } from '@/components/game-planner/GamePlanDisplay';
import { GamePlan } from '@/types/gamePlanner';

const SharedGamePlan = () => {
  const { shareId } = useParams();
  const [gamePlan, setGamePlan] = useState<GamePlan | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchGamePlan = async () => {
      if (!shareId) {
        setError('No share ID provided');
        setLoading(false);
        return;
      }

      try {
        const plan = await getSharedGamePlan(shareId);
        if (plan) {
          setGamePlan(plan);
        } else {
          setError('Game plan not found');
        }
      } catch (err) {
        setError('Failed to load game plan');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchGamePlan();
  }, [shareId]);

  if (loading) {
    return <div className="container mx-auto px-4 py-8">Loading game plan...</div>;
  }

  if (error) {
    return <div className="container mx-auto px-4 py-8 text-center">
      <p className="text-destructive">{error}</p>
    </div>;
  }

  if (!gamePlan) {
    return <div className="container mx-auto px-4 py-8 text-center">
      <p>Game plan not found</p>
    </div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <GamePlanDisplay gamePlan={gamePlan} />
    </div>
  );
};

export default SharedGamePlan;
